<template>
  <div>
    <GenericBTable
      :items="matrix2_capacities"
      :fields="fields"
      :filter="input_search"
      :filterCustom="filterCustom"
      :columns_display="false"
      @emitChangeSearchField="changeInputSearch"
    >
      <template #head(selected)>
        <b-checkbox
          v-model="all_selected"
          @change="selectAll"
          v-b-tooltip.v-secondary="
            all_selected
              ? $t('reusable.common.deselectAll')
              : $t('reusable.common.selectAll')
          "
        ></b-checkbox>
      </template>
      <template #cell(selected)="row">
        <b-checkbox
          v-model="row.item.selected"
          @input="selectCapacity(row.item.id, $event)"
        ></b-checkbox>
      </template>
    </GenericBTable>
    <div class="d-flex">
      <b-button class="btn-cancel" size="sm" @click="$emit('close_modal')">
        {{ $t("reusable.common.cancel") }}
      </b-button>
      <b-button size="sm" class="mr-3" @click="save">{{
        $t("reusable.common.save")
      }}</b-button>
    </div>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { toast } from "@/utils/utils";

export default {
  name: "CapacityTable",
  components: {
    GenericBTable: () => import("@/components/reusable/GenericBTable.vue"),
  },
  props: {
    matter: {
      type: Object,
      required: true,
    },
    competence_selected_ids: {
      type: Array,
    },
    matrix2_competences: {
      type: Array,
    },
  },
  data() {
    return {
      input_search: "",
      all_selected: false,
      matrix2_capacities: [],
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
      capacities: names.CAPACITIES,
    }),
    egressProfileCapacitiesIds() {
      let capacities = [];
      this.matrix2_competences.forEach((element) => {
        if (this.competence_selected_ids.includes(element.id))
          capacities = capacities.concat(element.capacities);
      });
      return [...new Set(capacities)];
    },
    fields() {
      return [
        {
          key: "selected",
          label: this.$t("reusable.common.selectLabel"),
          display_column: true,
          thStyle: { width: "1%" },
        },
        {
          key: "name",
          label: this.$getVisibleNames("mesh.capacity", true, "Capacidades"),
          display_column: true,
          tdClass: "text-left",
        },
      ];
    },
  },
  methods: {
    changeInputSearch(input_search) {
      this.input_search = input_search;
    },
    filterCustom(row) {
      if (this.$filtered(row.name, this.input_search)) return true;
      else return false;
    },
    selectAll(event) {
      this.matrix2_capacities.forEach((matrix2_capacities) => {
        matrix2_capacities.selected = event;
      });
    },
    selectCapacity(capacity_id, event) {
      const index = this.matrix2_capacities.findIndex(
        (x) => x.id == capacity_id
      );
      if (index != -1) {
        this.matrix2_capacities[index].selected = event;
        if (
          this.matrix2_capacities.filter((x) => x.selected).length ==
          this.matrix2_capacities.length
        )
          this.all_selected = true;
        else this.all_selected = false;
      }
    },
    save() {
      this.$store
        .dispatch(names.PATCH_EGRESS_PROFILE_MATTER, {
          egress_profile_matter_id: this.matter.id,
          item: {
            capacities: this.matrix2_capacities
              .filter((x) => x.selected == true)
              .map((x) => x.id),
          },
        })
        .then(() => {
          toast(
            this.$getVisibleNames("mesh.capacity", true, "Capacidades") +
              " " +
              this.$t("matrix2.matrix2View.updatedPlural")
          );
          this.$emit("close_modal");
        });
    },
  },
  mounted() {
    this.matrix2_capacities = this.capacities
      .filter((x) => this.egressProfileCapacitiesIds.includes(x.id))
      .map((x) => ({ ...x, selected: this.matter.capacities.includes(x.id) }));
    if (
      this.matrix2_capacities.filter((x) => x.selected).length ==
      this.matrix2_capacities.length
    )
      this.all_selected = true;
  },
  created() {},
};
</script>

<style scoped>
.btn-cancel {
  margin-right: auto;
  margin-left: 1.2em;
}
</style>

